import {
    Domain,
} from 'app/requests/ValueMapping/ValueMapping.types'
import {
    ForecastCreateRawData,
} from '../ShortTermForecastCsvUpload.types'
import {
    propertiesToDomainMap,
} from '../ShortTermForecast.constants'

const getDomainMapping = (data: ForecastCreateRawData[]) => {
    const valuesMap = new Map<Domain, Set<string>>()

    data.forEach((record) => {
        Object.entries(record).forEach(([
            key,
            value,
        ]) => {
            const domain = propertiesToDomainMap[key]

            if (domain) {
                if (!valuesMap.has(domain)) {
                    valuesMap.set(domain, new Set<string>())
                }
                valuesMap.get(domain).add(value)
            }
        })
    })
    return valuesMap
}

export default getDomainMapping
